import React, {useEffect, useCallback, useState} from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {Collapse} from 'reactstrap';
// Import Data
import navdata from "../LayoutMenuData";
//i18n
import {withTranslation} from "react-i18next";
import withRouter from "../../Components/Common/withRouter";
import {useSelector} from "react-redux";
import {createSelector} from 'reselect';
import {getLoggedInUserRole} from "../../helpers/backend_helper";

const VerticalLayout = (props: any) => {
    const navData = navdata().props.children;
    const path = props.router.location.pathname;
    // const [menuItems, setMenuItems] = useState<any>([]);
    const [userRole, setUserRole] = useState<number>(0);

    /*
     layout settings
     */
    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            leftsidbarSizeType: layout.leftsidbarSizeType,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
            layoutType: layout.layoutType
        })
    );
    // Inside your component
    const {
        leftsidbarSizeType, sidebarVisibilitytype, layoutType
    } = useSelector(selectLayoutProperties);

    //vertical and semibox resize events
    const resizeSidebarMenu = useCallback(() => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (windowSize >= 1025) {
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
            }
            if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.remove("open");
                }
            } else {
                // var hamburgerIcon = document.querySelector(".hamburger-icon");
                if (hamburgerIcon !== null) {
                    hamburgerIcon.classList.add("open");
                }
            }

        } else if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("twocolumn-panel");
            if (document.documentElement.getAttribute("data-layout") === "vertical") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (document.documentElement.getAttribute("data-layout") === "semibox") {
                document.documentElement.setAttribute("data-sidebar-size", "sm");
            }
            if (humberIcon) {
                humberIcon.classList.add("open");
            }
        } else if (windowSize <= 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
                document.documentElement.setAttribute("data-sidebar-size", "lg");
            }
            if (humberIcon) {
                humberIcon.classList.add("open");
            }
        }
    }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);


    useEffect(() => {
        setUserRole(getLoggedInUserRole() || 0)

    }, []);

    useEffect(() => {
        window.addEventListener("resize", resizeSidebarMenu, true);
        return () => {
            window.removeEventListener("resize", resizeSidebarMenu, true);
        };
    }, [resizeSidebarMenu]);

    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const ul = document.getElementById("navbar-nav");
            if (!ul) {
                return;
            }
            const items: any = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === "vertical") {
            initMenu();
        }
    }, [path, props.layoutType]);

    function activateParentDropdown(item: any) {
        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {
            // to set aria expand true remaining
            const parentElement = parentCollapseDiv.parentElement;
            const parentTrigger = parentElement?.children?.[0] as HTMLElement | undefined;

            parentCollapseDiv.classList.add("show");
            parentTrigger?.classList.add("active");
            parentTrigger?.setAttribute("aria-expanded", "true");

            const parentMenu = parentElement?.closest(".collapse.menu-dropdown") as HTMLElement | null;
            if (parentMenu) {
                parentMenu.classList.add("show");

                const previousMenuLink = parentMenu.previousElementSibling as HTMLElement | null;
                previousMenuLink?.classList.add("active");

                const previousMenu = previousMenuLink?.closest(".collapse") as HTMLElement | null;
                previousMenu?.classList.add("show");

                const previousMenuTrigger = previousMenu?.previousElementSibling as HTMLElement | null;
                previousMenuTrigger?.classList.add("active");
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items: any) => {
        let actiItems = items.filter((x: any) => x.classList.contains("active"));

        actiItems.forEach((item: any) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    const getLinkTargetProps = (menuItem: any) => ({
        ...(menuItem?.target ? {target: menuItem.target} : {}),
        ...(menuItem?.target === "_blank" ? {rel: "noopener noreferrer"} : {}),
    });

    return (
        <React.Fragment>
            {/* menu Items */}
            {(navData || []).map((item: any, key: number) => {
                //console.log(item)
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {item['isHeader'] ?
                            <li className="menu-title">
                                <span data-key="t-menu">{props.t(item.label)} </span>
                            </li>
                            : (
                                (item.subItems ? (
                                    (item.access.includes(userRole) ? (
                                        <li className="nav-item">
                                            <Link
                                                onClick={item.click}
                                                className="nav-link menu-link"
                                                to={item.link ? item.link : "/#"}
                                                data-bs-toggle="collapse"
                                            >
                                                <i className={item.icon}></i>
                                                <span data-key="t-apps">{props.t(item.label)}</span>
                                                {item.badgeName ?
                                                    <span className={"badge badge-pill bg-" + item.badgeColor}
                                                          data-key="t-new">{item.badgeName}</span>
                                                    : null}
                                            </Link>
                                            <Collapse
                                                className="menu-dropdown"
                                                isOpen={item.stateVariables}
                                                id="sidebarApps">
                                                <ul className="nav nav-sm flex-column test">
                                                    {/* subItms  */}
                                                    {item.subItems && ((item.subItems || []).map((subItem: any, key: number) => (
                                                            <React.Fragment key={key}>
                                                                {!subItem.isChildItem ? (
                                                                    (subItem.access.includes(userRole) ? (
                                                                        <li className="nav-item">

                                                                            <Link
                                                                                to={subItem.link ? subItem.link : "/#"}
                                                                                className="nav-link"
                                                                                {...getLinkTargetProps(subItem)}
                                                                            >
                                                                                {props.t(subItem.label)}
                                                                                {subItem.badgeName ?
                                                                                    <span
                                                                                        className={"badge badge-pill bg-" + subItem.badgeColor}
                                                                                        data-key="t-new">{subItem.badgeName}</span>
                                                                                    : null}
                                                                            </Link>
                                                                        </li>) : (''))
                                                                ) : (
                                                                    <li className="nav-item">
                                                                        <Link
                                                                            onClick={subItem.click}
                                                                            className="nav-link"
                                                                            to="/#"
                                                                            data-bs-toggle="collapse"
                                                                        >
                                                                            {props.t(subItem.label)}
                                                                            {subItem.badgeName ?
                                                                                <span
                                                                                    className={"badge badge-pill bg-" + subItem.badgeColor}
                                                                                    data-key="t-new">{subItem.badgeName}</span>
                                                                                : null}
                                                                        </Link>
                                                                        <Collapse className="menu-dropdown"
                                                                                  isOpen={subItem.stateVariables}
                                                                                  id="sidebarEcommerce">
                                                                            <ul className="nav nav-sm flex-column">
                                                                                {/* child subItms  */}
                                                                                {subItem.childItems && (
                                                                                    (subItem.childItems || []).map((childItem: any, key: number) => (
                                                                                        <React.Fragment key={key}>
                                                                                            {!childItem.childItems ?
                                                                                                <li className="nav-item">
                                                                                                    <Link
                                                                                                        to={childItem.link ? childItem.link : "/#"}
                                                                                                        className="nav-link"
                                                                                                        {...getLinkTargetProps(childItem)}>
                                                                                                        {props.t(childItem.label)}
                                                                                                    </Link>
                                                                                                </li>
                                                                                                :
                                                                                                <li className="nav-item">
                                                                                                    <Link to="/#"
                                                                                                          className="nav-link"
                                                                                                          onClick={childItem.click}
                                                                                                          data-bs-toggle="collapse">
                                                                                                        {props.t(childItem.label)}
                                                                                                    </Link>
                                                                                                    <Collapse
                                                                                                        className="menu-dropdown"
                                                                                                        isOpen={childItem.stateVariables}
                                                                                                        id="sidebaremailTemplates">
                                                                                                        <ul className="nav nav-sm flex-column">
                                                                                                            {childItem.childItems.map((subChildItem: any, key: number) => (
                                                                                                                <li className="nav-item"
                                                                                                                    key={key}>
                                                                                                                <Link
                                                                                                                    to={subChildItem.link}
                                                                                                                    className="nav-link"
                                                                                                                    {...getLinkTargetProps(subChildItem)}
                                                                                                                    data-key="t-basic-action">{props.t(subChildItem.label)} </Link>
                                                                                                            </li>
                                                                                                            ))}
                                                                                                        </ul>
                                                                                                    </Collapse>
                                                                                                </li>
                                                                                            }
                                                                                        </React.Fragment>
                                                                                    ))
                                                                                )}
                                                                            </ul>
                                                                        </Collapse>
                                                                    </li>
                                                                )}
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                </ul>

                                            </Collapse>
                                        </li>) : (''))
                                ) : (
                                    (item.access.includes(userRole) ? (
                                        <li className="nav-item">
                                            <Link
                                                className="nav-link menu-link"
                                                to={item.link ? item.link : "/#"}
                                                {...getLinkTargetProps(item)}>
                                                <i className={item.icon}></i> <span>{props.t(item.label)}</span>
                                                {item.badgeName ?
                                                    <span className={"badge badge-pill bg-" + item.badgeColor}
                                                          data-key="t-new">{item.badgeName}</span>
                                                    : null}
                                            </Link>
                                        </li>) : (''))
                                ))
                            )
                        }
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
